const textProps = {
  infoCards: [
    {
      icon: "fas fa-award",
      iconColor: "lightBlue",
      title: "Technical Assessment",
      description:
        "Our team of experts conducts an in-depth analysis of relevant industry trends and target audiences, understands use cases and discusses business objectives, assesses the technical landscape, and takes calculated risks.",
    },
    {
      icon: "fas fa-puzzle-piece",
      iconColor: "lightBlue",
      title: "Product Ideation",
      description:
        "Our team leverages the insights gathered in the initial assessment to craft a product idea that addresses the goals and provides a fit for the end users. Also, ensure that it meets the technical dependencies, and prioritize features.",
    },
    {
      icon: "fas fa-code",
      iconColor: "lightBlue",
      title: "Solution Architecture",
      description:
        "Following a thorough assessment of the IT landscape and product requirements, our experts plan, design, and develop a solution architecture that fully meets the business needs and aligns with technological preferences.",
    },
    {
      icon: "fas fa-link",
      iconColor: "lightBlue",
      title: "Proof of Concept",
      description:
        "Our experts help you test the feasibility of your software product idea and accurately identify its benefits and drawbacks by developing a pilot project demonstrating that a design concept or business proposal is feasible.",
    },
    {
      icon: "fas fa-window-maximize",
      iconColor: "lightBlue",
      title: "Minimum Viable Product",
      description:
        "We can develop an MVP of your solution to gain valuable feedback from the end-users, improve the product features, attract early-adopter customers, and validate a product idea early in the product development cycle.",
    },
    {
      icon: "fas fa-headset",
      iconColor: "lightBlue",
      title: "Support & Maintenance",
      description:
        "With our ideas and testing services, we strive to deliver a superior level of software quality, a simple deployment process, and a short time-to-market for our clients, as well as develop an up-to-date solution architecture.",
    },
  ],
};
export default textProps;
